import axios from 'axios';
import { API_PATH } from '../constants/ApiPath';
import { message } from 'antd';

let store;

/**
 * @author                                  Jay Vishwakarma
 * @description                             This Function Injects Store into `api.js` file
 * @param {object}    _store                Redux Store
 */
export const injectStoreToAPI = (_store) => {
  store = _store;
};

/**
 * @author                                  Jay Vishwakarma
 * @description                             This Function returns BaseURL based on Environment (DEV | STAG | PROD)
 *                                          currently hardcoded STAG Path is set.
 */
export const getBaseUrl = async () => {
  return API_PATH;
};

/**
 * @author                                  Jay Vishwakarma
 * @description                             This variable is an instance of axios to intercept request and response
 *                                          to do something with it if needed.
 */
const axiosInstance = axios.create({
  baseURL: API_PATH, // STAG
  timeout: 30000,
});

axiosInstance.interceptors.request.use(
  async config => {
    const baseURL = await getBaseUrl();
    config.baseURL = baseURL;
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Token ${token}`;
      }
    return config;
  },
  error => {
    // console.log('Request Error', error);
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  response => {
    // console.log('Interceptor response', response);
    return response;
  },
  error => {
    /** The below (if) condition will get executed
      whenever the uniserved services are under maintenance */
    // console.log('[INTERCEPTOR] ', JSON.stringify(error));
    if (error.response?.status >= 500) {
      // console.log('Maintenance of Uniserved services in progress');
    } else if (error?.response?.data?.code === 'kyc_incomplete') {
      // KYC-blocked callers show their own message; skip the duplicate toast here.
    } else {
      let errormessage = error?.response?.data?.message || 'Something went wrong!';
      if (error?.response?.status === 401) {
        errormessage = 'Invalid Credentials!';
      }
      message.error(errormessage, 1)
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
